module.exports = __webpack_public_path__ + "img/shengtai-active.809ffcb0.svg";